import React from 'react'

const AllergiesToolTip = ({allergies}) => {
  return (
    <div className='bg-gray-20 p-2 max-w-md flex flex-col'>
        <div className="text-teal-300 text-left text-body-sm font-normal capitalize">
        {allergies}
        </div>
    </div>
  )
}

export default AllergiesToolTip